import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const TitleWrapper = styled.div`
  padding: ${Spacing.S12};
  border-radius: ${BorderRadius.R12};
  background-color: ${Color.Green100};
`
